import * as yup from "yup";
import { ICreateGatewayTransfer } from "../../../../../interfaces-and-types";

export const singleGatewayTransferSchema: yup.SchemaOf<ICreateGatewayTransfer> =
  yup
    .object({
      // actual transfer details
      reference: yup.string().required("Reference is required"),
      beneficiary_id: yup.string().nullable().optional(),
      country: yup.string().required("Country is required"),
      recipient_gateway_code: yup
        .string()
        .required("Recipient gateway code is required"),
      merchant_id_or_code: yup
        .string()
        .required("Merchant id/code is required"),
      amount: yup
        .number()
        .transform((_value, originalValue) =>
          !originalValue
            ? 0
            : Number(originalValue.toString().replace(/,/g, ""))
        )
        .required("Amount is required")
        .positive("Amount must be greater than zero"),
      currency: yup.string().required("Currency is required"),
      description: yup.string().nullable().optional().max(300),
      save_as_beneficiary: yup.boolean().nullable().optional(),
      wallet_account_tags: yup
        .array()
        .of(
          yup.object().shape({
            account_tag: yup.string().required("Account tag is required"),
            amount: yup
              .number()
              // .nullable()
              .typeError("Amount is required")
              .required("Amount to tag to wallet is required")
              .positive("Amount must be greater than zero")
              .min(0),
            description: yup.string().nullable().optional().max(300),
            metadata: yup
              .mixed()
              .nullable()
              .test("metadata-test", "Invalid metadata", (value) => {
                if (value === null) {
                  return true;
                }
                if (typeof value !== "object") {
                  return false;
                }
                // test if every key in metadata has a string or object value
                return Object.values(value).every(
                  (v) =>
                    typeof v === "string" ||
                    typeof v === "number" ||
                    typeof v === "object"
                );
              }),
          })
        )
        .nullable()
        .optional(),

      // helper properties for batch upload mode
      beneficiaryName: yup.string().nullable().optional(),
      beneficiaryEmail: yup.string().nullable().optional(),
      isBeneficiaryResolved: yup.boolean().required(),
      isLoadingResolveBeneficiary: yup.boolean().required(),
      isErrorResolveBeneficiary: yup.boolean().required(),

      // helpers for edit mode in batch list
      isEditModeHelper: yup.boolean().optional(),
      tempEditModeAmount: yup.number().optional(),

      // helpers to display details in  batch list after insertion in list
      merchantNameHelper: yup.string().nullable().optional(),
      gatewayNameHelper: yup.string().nullable().optional(),
      fullNameHelper: yup.string().nullable().optional(),
    })
    .required();
